// extracted by mini-css-extract-plugin
export default {"submenu":"SubMenu_submenu__1YgA1"};